import { saveAs } from 'file-saver';

interface ExportCsvArgs {
  formattedData: any[];
  fileName: string;
  fileType?: 'csv' | 'xlsx' | 'txt'; // Optional for backward compatibility, only CSV is supported
}

export const useExportCsv = () => {
  const exportCsv = ({ formattedData, fileName }: ExportCsvArgs) => {
    // Convert JSON data to CSV format
    if (formattedData.length === 0) {
      return;
    }

    // Extract headers from the first object
    const headers = Object.keys(formattedData[0]);

    // Create CSV header row
    const csvHeader = headers.join(',');

    // Create CSV data rows
    const csvRows = formattedData.map((row) => {
      return headers
        .map((header) => {
          const value = row[header];
          // Handle values that contain commas, quotes, or newlines
          if (value === null || value === undefined) {
            return '';
          }
          const stringValue = String(value);
          if (
            stringValue.includes(',') ||
            stringValue.includes('"') ||
            stringValue.includes('\n')
          ) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        })
        .join(',');
    });

    // Combine header and rows
    const csvContent = [csvHeader, ...csvRows].join('\n');

    // Create blob and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, fileName);
  };

  return { exportCsv };
};
